import React from "react";
import { Container } from "react-bootstrap";
import svg from './icon.svg'
const icon = <img src={svg} alt="icon" style={{ height: 24, width: 24 }} />
const instagramLink = <a href="https://www.instagram.com/amigurumi.magia/" className="link text-warning ml-1 mr-1">@amigurumi.magia</a>


const Footer = () => {
    return(       
        <footer className="bd-footer text-primary pt-4">
            <Container>    
                <p className="row">2022 - Amigurumi Magia - {instagramLink} {icon}</p>
            </Container>
        </footer>
    )
}

export default Footer;